module.exports = __webpack_public_path__ + "static/media/rectangle-6.2a7b34f6.svg";